import React from "react";

import { ReactComponent as InfoIcon } from "@common/assets/images/info-icon-outline.svg";
import Tooltip from "@common/components/Tooltip/Tooltip";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";

import * as Styled from "./ModalHeader.styles";

export type ModalHeaderProps = {
  heading?: string;
  subtitle?: string;
  className?: string;
  iconPath?: string;
  testId?: string;
  info?: string;
  onInfoClick?: () => void;
  hasSeparator?: boolean;
  noContent?: boolean;
};

export const ModalHeader = ({
  heading,
  subtitle,
  iconPath,
  testId,
  info,
  onInfoClick,
  hasSeparator = true,
  noContent,
}: ModalHeaderProps) => {
  return (
    <Styled.Flex
      $column
      $gap={2.4}
      $hasSeparator={hasSeparator}
      $noContent={noContent}
    >
      <Flex $gap={1.4}>
        {iconPath && <Styled.Logo src={iconPath} />}
        <Styled.Title
          heading3
          data-testid={testId}
          marginBottom={0}
        >
          {heading}
        </Styled.Title>
        {info && (
          <Tooltip
            style={{ width: "auto", display: "flex" }}
            text={info}
            position={"bottom"}
          >
            <Styled.Info onClick={onInfoClick}>
              <InfoIcon
                width={24}
                height={24}
              />
            </Styled.Info>
          </Tooltip>
        )}
      </Flex>
      {subtitle && <Styled.Subtitle>{subtitle}</Styled.Subtitle>}
    </Styled.Flex>
  );
};
